module.exports = __webpack_public_path__ + "img/1.9b6a6d13.webp";